export default function getClientPath() {
    if (
        process.env.CLIENT_PUBLIC_URL &&
        process.env.CLIENT_PUBLIC_URL.length > 1
    )
        return process.env.CLIENT_PUBLIC_URL;
    return '';
}
